var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 283.5 283.5",
    style: {
      enableBackground: "new 0 0 283.5 283.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#020203;}\r\n\t.st1{fill:url(#SVGID_1_);}\r\n\t.st2{fill:url(#SVGID_00000042011154199454106990000000444076685170358441_);}\r\n\t.st3{fill:url(#SVGID_00000119821860833922984400000006675337550939485573_);}\r\n\t.st4{fill:url(#SVGID_00000155134403001085677760000008269227808270457485_);}\r\n\t.st5{fill:url(#SVGID_00000119814400446757373050000009589066790494985388_);}\r\n\t.st6{fill:url(#SVGID_00000147918872255617960300000005567033766167347094_);}\r\n\t.st7{fill:url(#SVGID_00000069374228725336574970000014634412477205721510_);}\r\n\t.st8{fill:url(#SVGID_00000088128915074348896950000015951602420541216657_);}\r\n\t.st9{fill:url(#SVGID_00000055706079337677047700000010436238849659850936_);}\r\n\t.st10{fill:url(#SVGID_00000009558406159684096690000009002016226169003418_);}\r\n\t.st11{fill:url(#SVGID_00000019636557333106659780000012345489745251796155_);}\r\n\t.st12{fill:url(#SVGID_00000151536831880507589060000015026933641064807306_);}\r\n\t.st13{fill:url(#SVGID_00000042715783780143393410000010861518214476880258_);}\r\n\t.st14{fill:url(#SVGID_00000173122031527259345600000010524355799163292553_);}\r\n\t.st15{fill:url(#SVGID_00000079449134379242764140000016750369865137283512_);}\r\n\t.st16{fill:url(#SVGID_00000132801915426694091550000018193048148245560737_);}\r\n\t.st17{fill:url(#SVGID_00000157291816475876600510000012162797538640361881_);}\r\n\t.st18{fill:url(#SVGID_00000178196308845130116420000014758209521559841714_);}\r\n\t.st19{fill:url(#SVGID_00000168801402345815835440000000466383580676014211_);}\r\n\t.st20{fill:url(#SVGID_00000103262172693941119580000004530866991529016195_);}\r\n\t.st21{fill:url(#SVGID_00000134246274398403515590000015116702142986692029_);}\r\n\t.st22{fill:url(#SVGID_00000180327183561866819580000017201645611090363561_);}\r\n\t.st23{fill:url(#SVGID_00000042720218273935338650000004280080497136686987_);}\r\n\t.st24{fill:url(#SVGID_00000159459517414143491580000004824454437293047216_);}\r\n\t.st25{fill:url(#SVGID_00000114032757769358229540000005235725024596649884_);}\r\n\t.st26{fill:url(#SVGID_00000098214074220219950260000007145932201567723441_);}\r\n\t.st27{fill:url(#SVGID_00000058560139855632810880000016778001571037940159_);}\r\n\t.st28{fill:url(#SVGID_00000054966268630348304300000015930146015824159380_);}\r\n\t.st29{fill:url(#SVGID_00000111889632468994555960000004007709541497464473_);}\r\n\t.st30{fill:url(#SVGID_00000030453247597400505100000009923024314527147167_);}\r\n\t.st31{fill:url(#SVGID_00000135691279903798631760000018119034167059114375_);}\r\n\t.st32{fill:url(#SVGID_00000142167528309461372330000012080333449081600929_);}\r\n\t.st33{fill:url(#SVGID_00000018198158699335395260000004250983339912613258_);}\r\n\t.st34{fill:url(#SVGID_00000085229386590971014600000003661346587878114238_);}\r\n\t.st35{fill:url(#SVGID_00000132777421227946337640000018327226428718522289_);}\r\n\t.st36{fill:url(#SVGID_00000149351826178119869440000007767149638296561543_);}\r\n\t.st37{fill:url(#SVGID_00000039817132900265476960000000812573004342692265_);}\r\n\t.st38{fill:url(#SVGID_00000017500357555318139710000011230587417094769280_);}\r\n\t.st39{fill:url(#SVGID_00000008837936957081359530000000886268974179019960_);}\r\n\t.st40{fill:url(#SVGID_00000099635673101371134160000014057777875247906976_);}\r\n\t.st41{fill:url(#SVGID_00000077316728180916032190000004794191964148744878_);}\r\n\t.st42{fill:url(#SVGID_00000060718743347584988530000010203987421709661614_);}\r\n\t.st43{fill:url(#SVGID_00000051351525565326578310000004166316424661867439_);}\r\n\t.st44{fill:url(#SVGID_00000040565202038472935120000005965275750941904035_);}\r\n\t.st45{fill:url(#SVGID_00000098217184457660781630000016678045774848928391_);}\r\n\t.st46{fill:url(#SVGID_00000085245075288787392620000015025694616951727783_);}\r\n\t.st47{fill:url(#SVGID_00000086669091814920713320000008715960428302343061_);}\r\n\t.st48{fill:url(#SVGID_00000074427635854069385650000011911236191805512836_);}\r\n\t.st49{fill:url(#SVGID_00000087389481866802810680000014011769636634935449_);}\r\n\t.st50{fill:url(#SVGID_00000047037016007461910620000001299375545353056696_);}\r\n\t.st51{fill:url(#SVGID_00000096026630266705900350000002569475553320379559_);}\r\n\t.st52{fill:url(#SVGID_00000038375098374508546840000008791134619210948225_);}\r\n\t.st53{fill:url(#SVGID_00000069356762039525055420000003710675244862523554_);}\r\n\t.st54{fill:url(#SVGID_00000003785653398813423160000002566934633018992035_);}\r\n\t.st55{fill:url(#SVGID_00000003826401261192612710000015961093878714589104_);}\r\n\t.st56{fill:url(#SVGID_00000027580146930209772130000002200360383773707943_);}\r\n\t.st57{fill:url(#SVGID_00000071523937126201081710000012540143046350877600_);}\r\n\t.st58{fill:url(#SVGID_00000166669300332805500710000012719614706826586515_);}\r\n\t.st59{fill:url(#SVGID_00000151507773098979382580000001610492535056045496_);}\r\n\t.st60{fill:url(#SVGID_00000057127209676918997810000017526231955809084056_);}\r\n\t.st61{fill:url(#SVGID_00000116208890023586228810000000494583715048248464_);}\r\n\t.st62{fill:url(#SVGID_00000173146781596098234890000000092469063437934003_);}\r\n\t.st63{fill:url(#SVGID_00000152262848175625967470000005363122614545801873_);}\r\n\t.st64{fill:url(#SVGID_00000054964360497481742430000006517898998772226736_);}\r\n\t.st65{fill:url(#SVGID_00000044888537518170589140000002704608942910015392_);}\r\n\t.st66{fill:url(#SVGID_00000065050303990475437410000001479084851848551559_);}\r\n\t.st67{fill:url(#SVGID_00000110465873883694474740000007500597093272510639_);}\r\n\t.st68{fill:url(#SVGID_00000009563211592920443550000001775180821529019053_);}\r\n\t.st69{fill:url(#SVGID_00000074407541647561680750000016603386956066189747_);}\r\n\t.st70{fill:url(#SVGID_00000114753851641847464440000015367892278393780368_);}\r\n\t.st71{fill:url(#SVGID_00000123427954150386907740000004670312430111909806_);}\r\n\t.st72{fill:url(#SVGID_00000152226703463340624600000015148922853511348104_);}\r\n\t.st73{fill:url(#SVGID_00000045607003213962043700000016408640165845729153_);}\r\n\t.st74{fill:url(#SVGID_00000155129588044294944140000010296241423285889416_);}\r\n\t.st75{fill:url(#SVGID_00000028326427567889176520000009923993168865455545_);}\r\n\t.st76{fill:url(#SVGID_00000183242101334602550990000002489690865789851306_);}\r\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: -3380.2734,
    y1: 141.8012,
    x2: -3363.8347,
    y2: 125.3626,
    gradientTransform: "matrix(-0.9654 0 0 1 -3123.8884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M131.4,148.1c2.5,0,4.5-2.1,4.5-4.7v-19.7c0-2.6-2-4.7-4.5-4.7s-4.5,2.1-4.5,4.7v19.7 C126.9,146,128.9,148.1,131.4,148.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000003072710696756504960000015466240615630915768_",
    gradientUnits: "userSpaceOnUse",
    x1: -3369.8149,
    y1: 134.7425,
    x2: -3339.2588,
    y2: 104.1865,
    gradientTransform: "matrix(-0.9654 0 0 1 -3123.8884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000003072710696756504960000015466240615630915768_)"
    },
    d: "M114.5,148.1c2.5,0,4.5-2.1,4.5-4.7V95.5 c0-2.6-2-4.7-4.5-4.7c-2.5,0-4.5,2.1-4.5,4.7v47.9C110,146,112,148.1,114.5,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000052805533056505501210000013795202390201395842_",
    gradientUnits: "userSpaceOnUse",
    x1: -3393.2493,
    y1: 145.2789,
    x2: -3383.7659,
    y2: 135.7956,
    gradientTransform: "matrix(-0.9654 0 0 1 -3123.8884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000052805533056505501210000013795202390201395842_)"
    },
    d: "M147.3,148.1c2.5,0,4.5-2.1,4.5-4.7v-5.8 c0-2.6-2-4.7-4.5-4.7c-2.5,0-4.5,2.1-4.5,4.7v5.8C142.8,146,144.8,148.1,147.3,148.1z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000105386812910584791920000013622375528705587840_",
    gradientUnits: "userSpaceOnUse",
    x1: -3433.6809,
    y1: 135.1066,
    x2: -3380.623,
    y2: 82.0487,
    gradientTransform: "matrix(-0.9654 0 0 1 -3123.8884 0)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000105386812910584791920000013622375528705587840_)"
    },
    d: "M176.5,148.1c2.5,0,4.5-2.1,4.5-4.7V97 c0-0.2,0-0.3,0-0.5c0,0-0.1-0.4-0.1-0.5l-0.1-0.4l-0.1-0.4l-0.2-0.4l-0.2-0.4c0,0-0.2-0.3-0.2-0.3c-0.2-0.3-0.4-0.5-0.7-0.7 c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.2-0.1-0.2-0.2l-0.4-0.2l-0.4-0.2l-0.4-0.2c0,0-0.4-0.1-0.4-0.1l-0.4-0.1c-0.1,0-0.3,0-0.4,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2,0-0.4,0l-0.4,0.1c0,0-0.4,0.1-0.4,0.1l-0.4,0.1l-0.4,0.2l-0.4,0.2c-0.1,0-0.1,0.1-0.1,0.1l-0.2,0.1 c-0.2,0.1-0.3,0.2-0.4,0.3l-18,18.6c-0.4,0.4-0.8,0.5-1.3,0.5c-0.5,0-0.9-0.2-1.3-0.5l-18-18.6c-0.9-0.9-2-1.4-3.2-1.4 c-1.2,0-2.3,0.5-3.2,1.4c-0.9,0.9-1.3,2.1-1.3,3.3c0,1.2,0.5,2.4,1.3,3.3l22.4,23.2c0.9,0.9,2,1.4,3.2,1.4c1.2,0,2.3-0.5,3.2-1.4 l11.6-12.1c0.3-0.4,0.8-0.5,1.3-0.5c0.2,0,0.5,0,0.7,0.1c0.7,0.3,1.1,1,1.1,1.7v30.7C172,146,174,148.1,176.5,148.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000124867659626494342300000011509649184237074828_",
    gradientUnits: "userSpaceOnUse",
    x1: 38.5252,
    y1: 175.634,
    x2: 45.3195,
    y2: 168.8398
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000124867659626494342300000011509649184237074828_)"
    },
    d: "M40.2,167.2h3.4v10.2h-3.4V167.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000034081801114785441910000007124796803040764040_",
    gradientUnits: "userSpaceOnUse",
    x1: 46.4845,
    y1: 177.5249,
    x2: 54.0229,
    y2: 169.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000034081801114785441910000007124796803040764040_)"
    },
    d: "M54.2,170.1c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3v-7.9h3.1v0.8c0.3-0.3,0.7-0.5,1.1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2C52.8,169.2,53.6,169.5,54.2,170.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007408570529960131870000016449611630525060031_",
    gradientUnits: "userSpaceOnUse",
    x1: 57.5695,
    y1: 175.4117,
    x2: 63.2958,
    y2: 169.6853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007408570529960131870000016449611630525060031_)"
    },
    d: "M63.4,177c-0.5,0.3-1.2,0.4-2,0.4 c-1.1,0-2-0.3-2.6-0.8c-0.6-0.5-0.9-1.3-0.9-2.4v-2h-1.1v-2.4h1.1v-2.2h3.3v2.2h1.6v2.4h-1.6v2c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2L63.4,177z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085244766398381482640000005510819849306229428_",
    gradientUnits: "userSpaceOnUse",
    x1: 66.2177,
    y1: 176.5304,
    x2: 72.3665,
    y2: 170.3816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000085244766398381482640000005510819849306229428_)"
    },
    d: "M73.5,174.1H68c0.1,0.3,0.3,0.5,0.6,0.7 c0.3,0.2,0.6,0.2,1,0.2c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.5-0.2,0.8-0.5l1.7,1.7c-0.8,0.9-1.9,1.3-3.5,1.3c-1,0-1.8-0.2-2.5-0.5 c-0.7-0.4-1.3-0.8-1.7-1.5c-0.4-0.6-0.6-1.3-0.6-2.1c0-0.8,0.2-1.5,0.6-2.1c0.4-0.6,0.9-1.1,1.6-1.5c0.7-0.3,1.4-0.5,2.3-0.5 c0.8,0,1.5,0.2,2.2,0.5c0.7,0.3,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.2C73.6,173.4,73.5,173.6,73.5,174.1z M68.4,171.7 c-0.2,0.2-0.4,0.4-0.4,0.8h2.6c-0.1-0.3-0.2-0.6-0.4-0.8c-0.2-0.2-0.5-0.3-0.8-0.3C68.9,171.5,68.6,171.6,68.4,171.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000130618908248827860660000017224639561746718882_",
    gradientUnits: "userSpaceOnUse",
    x1: 74.5107,
    y1: 176.153,
    x2: 81.3992,
    y2: 169.2645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000130618908248827860660000017224639561746718882_)"
    },
    d: "M81.4,169.2v2.9c-0.3,0-0.5-0.1-0.7-0.1 c-1.1,0-1.7,0.6-1.7,1.7v3.5h-3.3v-7.9h3.1v0.9C79.4,169.6,80.2,169.2,81.4,169.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000121253965614701615410000004365787224873298048_",
    gradientUnits: "userSpaceOnUse",
    x1: 83.5915,
    y1: 177.5249,
    x2: 91.1298,
    y2: 169.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000121253965614701615410000004365787224873298048_)"
    },
    d: "M91.3,170.1c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3v-7.9h3.1v0.8c0.3-0.3,0.7-0.5,1.1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2C89.9,169.2,90.7,169.5,91.3,170.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000038406432379813449680000017656538785113400196_",
    gradientUnits: "userSpaceOnUse",
    x1: 95.2931,
    y1: 177.0163,
    x2: 101.7849,
    y2: 170.5245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000038406432379813449680000017656538785113400196_)"
    },
    d: "M101.4,170.2c0.7,0.6,1.1,1.6,1.1,2.9v4.3 h-3v-1c-0.4,0.8-1.1,1.2-2.3,1.2c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1-0.9c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.8,0.3-1.4,0.9-1.8 c0.6-0.4,1.5-0.6,2.7-0.6h1.3c-0.1-0.6-0.6-0.9-1.5-0.9c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.3-0.9,0.5l-1-2.2 c0.5-0.3,1-0.5,1.6-0.7c0.6-0.2,1.3-0.2,1.9-0.2C99.6,169.2,100.7,169.5,101.4,170.2z M98.8,175.3c0.2-0.1,0.3-0.3,0.4-0.6v-0.6 h-0.8c-0.7,0-1,0.2-1,0.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2C98.4,175.5,98.6,175.4,98.8,175.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000007408594674769908890000008890037411887195321_",
    gradientUnits: "userSpaceOnUse",
    x1: 105.042,
    y1: 175.4117,
    x2: 110.7683,
    y2: 169.6853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000007408594674769908890000008890037411887195321_)"
    },
    d: "M110.9,177c-0.5,0.3-1.2,0.4-2,0.4 c-1.1,0-2-0.3-2.6-0.8c-0.6-0.5-0.9-1.3-0.9-2.4v-2h-1.1v-2.4h1.1v-2.2h3.3v2.2h1.6v2.4h-1.6v2c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2L110.9,177z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104683514215429103760000017943433607139314342_",
    gradientUnits: "userSpaceOnUse",
    x1: 110.8065,
    y1: 175.3274,
    x2: 118.0845,
    y2: 168.0494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104683514215429103760000017943433607139314342_)"
    },
    d: "M113,168.3c-0.4-0.3-0.5-0.7-0.5-1.2 s0.2-0.9,0.5-1.2c0.4-0.3,0.8-0.5,1.4-0.5c0.6,0,1.1,0.2,1.4,0.5c0.4,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2 c-0.4,0.3-0.8,0.5-1.4,0.5C113.8,168.7,113.4,168.6,113,168.3z M112.8,169.4h3.3v7.9h-3.3V169.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111904086341651841820000010292805963941577649_",
    gradientUnits: "userSpaceOnUse",
    x1: 119.6758,
    y1: 176.4852,
    x2: 125.9643,
    y2: 170.1967
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111904086341651841820000010292805963941577649_)"
    },
    d: "M120.4,176.9c-0.7-0.4-1.3-0.8-1.6-1.5 c-0.4-0.6-0.6-1.3-0.6-2.1c0-0.8,0.2-1.5,0.6-2.1c0.4-0.6,0.9-1.1,1.6-1.5c0.7-0.3,1.5-0.5,2.4-0.5c0.9,0,1.7,0.2,2.4,0.5 c0.7,0.3,1.2,0.8,1.6,1.5c0.4,0.6,0.6,1.3,0.6,2.1c0,0.8-0.2,1.5-0.6,2.1c-0.4,0.6-0.9,1.1-1.6,1.5c-0.7,0.4-1.5,0.5-2.4,0.5 C121.9,177.5,121.1,177.3,120.4,176.9z M123.7,174.5c0.2-0.3,0.4-0.7,0.4-1.2s-0.1-0.9-0.4-1.1c-0.2-0.3-0.6-0.4-0.9-0.4 s-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.7-0.4,1.1s0.1,0.9,0.4,1.2c0.2,0.3,0.6,0.4,0.9,0.4S123.5,174.8,123.7,174.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101825723801336510070000009455768641990623658_",
    gradientUnits: "userSpaceOnUse",
    x1: 129.7571,
    y1: 177.5249,
    x2: 137.2954,
    y2: 169.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101825723801336510070000009455768641990623658_)"
    },
    d: "M137.4,170.1c0.6,0.6,0.9,1.5,0.9,2.7v4.5 H135v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3v-7.9h3.1v0.8c0.3-0.3,0.7-0.5,1.1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2C136,169.2,136.8,169.5,137.4,170.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000073696325787590497030000017262202395458313635_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.4589,
    y1: 177.0163,
    x2: 147.9507,
    y2: 170.5245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000073696325787590497030000017262202395458313635_)"
    },
    d: "M147.6,170.2c0.7,0.6,1.1,1.6,1.1,2.9v4.3 h-3v-1c-0.4,0.8-1.1,1.2-2.3,1.2c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1-0.9c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.8,0.3-1.4,0.9-1.8 c0.6-0.4,1.5-0.6,2.7-0.6h1.3c-0.1-0.6-0.6-0.9-1.5-0.9c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.3-0.9,0.5l-1-2.2 c0.5-0.3,1-0.5,1.6-0.7c0.6-0.2,1.3-0.2,1.9-0.2C145.8,169.2,146.8,169.5,147.6,170.2z M145,175.3c0.2-0.1,0.3-0.3,0.4-0.6v-0.6 h-0.8c-0.7,0-1,0.2-1,0.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2C144.6,175.5,144.8,175.4,145,175.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000111870625445130266640000003997723924772948411_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.3231,
    y1: 175.4452,
    x2: 156.3497,
    y2: 168.4186
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000111870625445130266640000003997723924772948411_)"
    },
    d: "M151.2,166.5h3.3v10.8h-3.3V166.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000099653895176878628700000016636267448228222119_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.0709,
    y1: 177.8262,
    x2: 174.235,
    y2: 166.6621
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000099653895176878628700000016636267448228222119_)"
    },
    d: "M171.6,177.3l0-4.6l-2.2,3.7h-1.5 l-2.2-3.6v4.5h-3.1v-10.2h2.8l3.3,5.4l3.2-5.4h2.8l0,10.2H171.6z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000178893239143841187740000009202627886165907134_",
    gradientUnits: "userSpaceOnUse",
    x1: 178.0284,
    y1: 177.0163,
    x2: 184.5202,
    y2: 170.5245
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000178893239143841187740000009202627886165907134_)"
    },
    d: "M184.2,170.2c0.7,0.6,1.1,1.6,1.1,2.9v4.3 h-3v-1c-0.4,0.8-1.1,1.2-2.3,1.2c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1-0.9c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.8,0.3-1.4,0.9-1.8 c0.6-0.4,1.5-0.6,2.7-0.6h1.3c-0.1-0.6-0.6-0.9-1.5-0.9c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.3-0.9,0.5l-1-2.2 c0.5-0.3,1-0.5,1.6-0.7c0.6-0.2,1.3-0.2,1.9-0.2C182.4,169.2,183.4,169.5,184.2,170.2z M181.6,175.3c0.2-0.1,0.3-0.3,0.4-0.6v-0.6 h-0.8c-0.7,0-1,0.2-1,0.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2C181.2,175.5,181.4,175.4,181.6,175.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000104664450817973316490000002299492225193114513_",
    gradientUnits: "userSpaceOnUse",
    x1: 186.6004,
    y1: 176.153,
    x2: 193.4889,
    y2: 169.2645
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000104664450817973316490000002299492225193114513_)"
    },
    d: "M193.5,169.2v2.9c-0.3,0-0.5-0.1-0.7-0.1 c-1.1,0-1.7,0.6-1.7,1.7v3.5h-3.3v-7.9h3.1v0.9C191.5,169.6,192.3,169.2,193.5,169.2z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101091077890513513160000003515902279088699561_",
    gradientUnits: "userSpaceOnUse",
    x1: 195.2056,
    y1: 177.0494,
    x2: 203.8944,
    y2: 168.3607
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101091077890513513160000003515902279088699561_)"
    },
    d: "M199.3,174.9l-0.5,0.6v1.9h-3.3v-10.8h3.3 v5.1l2.3-2.3h3.9l-3.3,3.4l3.5,4.5h-4L199.3,174.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098179890096445899960000012751900879785252775_",
    gradientUnits: "userSpaceOnUse",
    x1: 207.6622,
    y1: 176.5304,
    x2: 213.811,
    y2: 170.3816
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098179890096445899960000012751900879785252775_)"
    },
    d: "M215,174.1h-5.5c0.1,0.3,0.3,0.5,0.6,0.7 c0.3,0.2,0.6,0.2,1,0.2c0.3,0,0.6,0,0.9-0.1c0.2-0.1,0.5-0.2,0.8-0.5l1.7,1.7c-0.8,0.9-1.9,1.3-3.5,1.3c-1,0-1.8-0.2-2.5-0.5 c-0.7-0.4-1.3-0.8-1.7-1.5c-0.4-0.6-0.6-1.3-0.6-2.1c0-0.8,0.2-1.5,0.6-2.1c0.4-0.6,0.9-1.1,1.6-1.5c0.7-0.3,1.4-0.5,2.3-0.5 c0.8,0,1.5,0.2,2.2,0.5c0.7,0.3,1.2,0.8,1.6,1.4c0.4,0.6,0.6,1.4,0.6,2.2C215,173.4,215,173.6,215,174.1z M209.8,171.7 c-0.2,0.2-0.4,0.4-0.4,0.8h2.6c-0.1-0.3-0.2-0.6-0.4-0.8c-0.2-0.2-0.5-0.3-0.8-0.3C210.3,171.5,210,171.6,209.8,171.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000063622095238624906750000011175547452257969031_",
    gradientUnits: "userSpaceOnUse",
    x1: 217.1319,
    y1: 175.4117,
    x2: 222.8582,
    y2: 169.6853
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000063622095238624906750000011175547452257969031_)"
    },
    d: "M223,177c-0.5,0.3-1.2,0.4-2,0.4 c-1.1,0-2-0.3-2.6-0.8c-0.6-0.5-0.9-1.3-0.9-2.4v-2h-1.1v-2.4h1.1v-2.2h3.3v2.2h1.6v2.4h-1.6v2c0,0.2,0.1,0.4,0.2,0.6 c0.1,0.1,0.3,0.2,0.5,0.2c0.3,0,0.5-0.1,0.7-0.2L223,177z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054258894515940913940000006696589572380378802_",
    gradientUnits: "userSpaceOnUse",
    x1: 222.8964,
    y1: 175.3274,
    x2: 230.1744,
    y2: 168.0494
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054258894515940913940000006696589572380378802_)"
    },
    d: "M225.1,168.3c-0.4-0.3-0.5-0.7-0.5-1.2 s0.2-0.9,0.5-1.2c0.4-0.3,0.8-0.5,1.4-0.5c0.6,0,1.1,0.2,1.4,0.5c0.4,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2 c-0.4,0.3-0.8,0.5-1.4,0.5C225.9,168.7,225.5,168.6,225.1,168.3z M224.9,169.4h3.3v7.9h-3.3V169.4z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000002363263796433617560000000629653731361677477_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.9154,
    y1: 177.5249,
    x2: 238.4537,
    y2: 169.9866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000002363263796433617560000000629653731361677477_)"
    },
    d: "M238.6,170.1c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3v-7.9h3.1v0.8c0.3-0.3,0.7-0.5,1.1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2C237.2,169.2,238,169.5,238.6,170.1z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150094340147338714070000008520800936800638906_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.9534,
    y1: 179.0541,
    x2: 251.3172,
    y2: 169.6902
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150094340147338714070000008520800936800638906_)"
    },
    d: "M251,169.4v6.4c0,1.5-0.4,2.6-1.3,3.4 c-0.8,0.8-2,1.1-3.6,1.1c-0.8,0-1.5-0.1-2.2-0.3c-0.7-0.2-1.3-0.4-1.8-0.7l1.1-2.2c0.3,0.2,0.7,0.4,1.2,0.6 c0.5,0.1,0.9,0.2,1.4,0.2c0.7,0,1.1-0.1,1.4-0.4c0.3-0.3,0.4-0.7,0.4-1.2V176c-0.5,0.6-1.2,0.8-2.2,0.8c-0.7,0-1.3-0.2-1.9-0.5 c-0.6-0.3-1.1-0.8-1.4-1.4c-0.3-0.6-0.5-1.3-0.5-2c0-0.8,0.2-1.4,0.5-2c0.3-0.6,0.8-1,1.4-1.3c0.6-0.3,1.2-0.5,1.9-0.5 c1.1,0,1.9,0.3,2.4,1v-0.9H251z M247.4,174c0.3-0.2,0.4-0.5,0.4-0.9c0-0.4-0.1-0.7-0.4-0.9c-0.3-0.2-0.6-0.3-1-0.3 c-0.4,0-0.7,0.1-1,0.3c-0.3,0.2-0.4,0.5-0.4,0.9c0,0.4,0.1,0.7,0.4,0.9c0.3,0.2,0.6,0.4,1,0.4C246.8,174.3,247.1,174.2,247.4,174z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000150799897278845241030000012533594232806603694_",
    gradientUnits: "userSpaceOnUse",
    x1: 84.916,
    y1: 193.6059,
    x2: 92.8115,
    y2: 185.7104
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000150799897278845241030000012533594232806603694_)"
    },
    d: "M86,194.3c-0.9-0.5-1.5-1.1-2-1.9 c-0.5-0.8-0.7-1.7-0.7-2.8c0-1,0.2-1.9,0.7-2.8c0.5-0.8,1.2-1.4,2-1.9c0.9-0.4,1.8-0.7,2.9-0.7c1,0,1.9,0.2,2.6,0.5 c0.8,0.3,1.4,0.9,1.9,1.5l-2.2,1.9c-0.6-0.8-1.4-1.2-2.2-1.2c-0.7,0-1.3,0.2-1.7,0.7c-0.4,0.5-0.7,1.1-0.7,1.9 c0,0.8,0.2,1.4,0.7,1.9c0.4,0.5,1,0.7,1.7,0.7c0.9,0,1.6-0.4,2.2-1.2l2.2,1.9c-0.5,0.7-1.1,1.2-1.9,1.5c-0.8,0.3-1.7,0.5-2.6,0.5 C87.8,195,86.8,194.7,86,194.3z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000054231985716340124250000007653695964079074192_",
    gradientUnits: "userSpaceOnUse",
    x1: 94.8895,
    y1: 194.2384,
    x2: 102.4279,
    y2: 186.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000054231985716340124250000007653695964079074192_)"
    },
    d: "M103.3,187.5c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3V184h3.3v3.5c0.6-0.5,1.4-0.8,2.2-0.8 C101.9,186.7,102.7,186.9,103.3,187.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000101083878305368149950000002296066963487754651_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.2989,
    y1: 194.4376,
    x2: 113.7908,
    y2: 187.9457
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000101083878305368149950000002296066963487754651_)"
    },
    d: "M113.4,187.6c0.7,0.6,1.1,1.6,1.1,2.9v4.3 h-3v-1c-0.4,0.8-1.1,1.2-2.3,1.2c-0.6,0-1.2-0.1-1.6-0.3c-0.4-0.2-0.8-0.5-1-0.9c-0.2-0.4-0.3-0.8-0.3-1.3c0-0.8,0.3-1.4,0.9-1.8 c0.6-0.4,1.5-0.6,2.7-0.6h1.3c-0.1-0.6-0.6-0.9-1.5-0.9c-0.4,0-0.7,0.1-1.1,0.2c-0.4,0.1-0.7,0.3-0.9,0.5l-1-2.2 c0.5-0.3,1-0.5,1.6-0.7c0.6-0.2,1.3-0.2,1.9-0.2C111.6,186.7,112.7,187,113.4,187.6z M110.8,192.7c0.2-0.1,0.3-0.3,0.4-0.6v-0.6 h-0.8c-0.7,0-1,0.2-1,0.7c0,0.2,0.1,0.3,0.2,0.5c0.1,0.1,0.3,0.2,0.6,0.2C110.4,192.9,110.7,192.8,110.8,192.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000098937088825482642410000010741585231778035122_",
    gradientUnits: "userSpaceOnUse",
    x1: 118.4697,
    y1: 196.1729,
    x2: 128.4762,
    y2: 186.1665
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000098937088825482642410000010741585231778035122_)"
    },
    d: "M129.8,187.5c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-0.9-1.4c-0.3,0-0.6,0.1-0.7,0.3c-0.2,0.2-0.3,0.6-0.3,1.1v3.9h-3.3v-4c0-0.9-0.3-1.4-0.9-1.4 c-0.3,0-0.6,0.1-0.7,0.3c-0.2,0.2-0.3,0.6-0.3,1.1v3.9H117v-7.9h3.1v0.7c0.6-0.6,1.3-0.9,2.3-0.9c0.5,0,1,0.1,1.4,0.3 c0.4,0.2,0.8,0.5,1,0.9c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1-0.3,1.5-0.3C128.5,186.7,129.3,186.9,129.8,187.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000057118527064357656470000014919875484696440759_",
    gradientUnits: "userSpaceOnUse",
    x1: 131.591,
    y1: 195.9236,
    x2: 140.4916,
    y2: 187.0229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000057118527064357656470000014919875484696440759_)"
    },
    d: "M140.4,187.2c0.6,0.3,1.1,0.8,1.4,1.4 c0.3,0.6,0.5,1.4,0.5,2.2s-0.2,1.5-0.5,2.2c-0.3,0.6-0.8,1.1-1.4,1.4c-0.6,0.3-1.2,0.5-1.9,0.5c-0.9,0-1.6-0.2-2-0.7v3.4h-3.3 v-10.8h3.1v0.7c0.5-0.5,1.2-0.8,2.2-0.8C139.2,186.7,139.9,186.8,140.4,187.2z M138.7,191.9c0.2-0.3,0.4-0.7,0.4-1.1 c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.7-0.4,1.2c0,0.5,0.1,0.9,0.4,1.1 c0.2,0.3,0.6,0.4,0.9,0.4C138.1,192.3,138.4,192.2,138.7,191.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000080906909021463219420000015386954929426901147_",
    gradientUnits: "userSpaceOnUse",
    x1: 142.4838,
    y1: 192.7486,
    x2: 149.7618,
    y2: 185.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000080906909021463219420000015386954929426901147_)"
    },
    d: "M144.7,185.7c-0.4-0.3-0.5-0.7-0.5-1.2 s0.2-0.9,0.5-1.2c0.4-0.3,0.8-0.5,1.4-0.5c0.6,0,1.1,0.2,1.4,0.5c0.4,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2 c-0.4,0.3-0.8,0.5-1.4,0.5C145.5,186.2,145,186,144.7,185.7z M144.5,186.8h3.3v7.9h-3.3V186.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000039849395013551592750000007766424609006171789_",
    gradientUnits: "userSpaceOnUse",
    x1: 151.3531,
    y1: 193.9064,
    x2: 157.6415,
    y2: 187.6179
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000039849395013551592750000007766424609006171789_)"
    },
    d: "M152.1,194.4c-0.7-0.4-1.3-0.8-1.6-1.5 c-0.4-0.6-0.6-1.3-0.6-2.1c0-0.8,0.2-1.5,0.6-2.1c0.4-0.6,0.9-1.1,1.6-1.5c0.7-0.3,1.5-0.5,2.4-0.5c0.9,0,1.7,0.2,2.4,0.5 c0.7,0.3,1.2,0.8,1.6,1.5c0.4,0.6,0.6,1.3,0.6,2.1c0,0.8-0.2,1.5-0.6,2.1c-0.4,0.6-0.9,1.1-1.6,1.5c-0.7,0.4-1.5,0.5-2.4,0.5 C153.6,194.9,152.8,194.7,152.1,194.4z M155.4,191.9c0.2-0.3,0.4-0.7,0.4-1.2c0-0.5-0.1-0.9-0.4-1.1c-0.2-0.3-0.6-0.4-0.9-0.4 s-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.7-0.4,1.1c0,0.5,0.1,0.9,0.4,1.2c0.2,0.3,0.6,0.4,0.9,0.4S155.2,192.2,155.4,191.9z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000026132215274841889450000005744673711857889948_",
    gradientUnits: "userSpaceOnUse",
    x1: 161.4344,
    y1: 194.9462,
    x2: 168.9727,
    y2: 187.4078
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000026132215274841889450000005744673711857889948_)"
    },
    d: "M169.1,187.5c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3v-7.9h3.1v0.8c0.3-0.3,0.7-0.5,1.1-0.7 c0.4-0.2,0.8-0.2,1.3-0.2C167.7,186.7,168.5,186.9,169.1,187.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000016785694714558394510000011305006831513063082_",
    gradientUnits: "userSpaceOnUse",
    x1: 172.3045,
    y1: 194.3907,
    x2: 179.4108,
    y2: 187.2844
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000016785694714558394510000011305006831513063082_)"
    },
    d: "M173.6,194.7c-0.7-0.1-1.2-0.3-1.6-0.6 l0.9-2.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,1,0.2,1.5,0.2c0.4,0,0.6,0,0.8-0.1c0.1-0.1,0.2-0.2,0.2-0.3s-0.1-0.2-0.3-0.3 c-0.2,0-0.5-0.1-0.9-0.1c-0.6-0.1-1.2-0.2-1.7-0.3c-0.5-0.1-0.9-0.4-1.2-0.7c-0.3-0.3-0.5-0.8-0.5-1.5c0-0.5,0.2-1,0.5-1.4 c0.3-0.4,0.8-0.7,1.4-1c0.6-0.2,1.4-0.4,2.2-0.4c0.6,0,1.2,0.1,1.8,0.2c0.6,0.1,1.1,0.3,1.5,0.5l-0.9,2.2c-0.7-0.4-1.5-0.6-2.3-0.6 c-0.7,0-1.1,0.1-1.1,0.4c0,0.1,0.1,0.2,0.3,0.3c0.2,0.1,0.5,0.1,0.9,0.2c0.6,0.1,1.2,0.2,1.6,0.3c0.5,0.1,0.8,0.4,1.2,0.7 c0.3,0.3,0.5,0.8,0.5,1.5c0,0.5-0.2,0.9-0.5,1.4c-0.3,0.4-0.8,0.7-1.4,1c-0.6,0.2-1.4,0.4-2.3,0.4 C174.9,194.9,174.3,194.8,173.6,194.7z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000089566187838324553500000017109312640766318258_",
    gradientUnits: "userSpaceOnUse",
    x1: 181.298,
    y1: 194.2384,
    x2: 188.8363,
    y2: 186.7
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000089566187838324553500000017109312640766318258_)"
    },
    d: "M189.7,187.5c0.6,0.6,0.9,1.5,0.9,2.7v4.5 h-3.3v-4c0-0.9-0.3-1.4-1-1.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.3,0.7-0.3,1.2v3.7h-3.3V184h3.3v3.5c0.6-0.5,1.4-0.8,2.2-0.8 C188.3,186.7,189.1,186.9,189.7,187.5z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000163066354196803817840000005415934847110451646_",
    gradientUnits: "userSpaceOnUse",
    x1: 191.0884,
    y1: 192.7486,
    x2: 198.3664,
    y2: 185.4707
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000163066354196803817840000005415934847110451646_)"
    },
    d: "M193.3,185.7c-0.4-0.3-0.5-0.7-0.5-1.2 s0.2-0.9,0.5-1.2c0.4-0.3,0.8-0.5,1.4-0.5c0.6,0,1.1,0.2,1.4,0.5c0.4,0.3,0.5,0.7,0.5,1.2c0,0.5-0.2,0.9-0.5,1.2 c-0.4,0.3-0.8,0.5-1.4,0.5C194.1,186.2,193.7,186,193.3,185.7z M193.1,186.8h3.3v7.9h-3.3V186.8z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000114769719660583695790000016234271393554581182_",
    gradientUnits: "userSpaceOnUse",
    x1: 197.2683,
    y1: 195.9236,
    x2: 206.1689,
    y2: 187.0229
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#85501B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.107,
    style: {
      stopColor: "#936124"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5394,
    style: {
      stopColor: "#D1B15C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.738,
    style: {
      stopColor: "#ECD679"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#85501B"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "url(#SVGID_00000114769719660583695790000016234271393554581182_)"
    },
    d: "M206.1,187.2c0.6,0.3,1.1,0.8,1.4,1.4 c0.3,0.6,0.5,1.4,0.5,2.2s-0.2,1.5-0.5,2.2c-0.3,0.6-0.8,1.1-1.4,1.4c-0.6,0.3-1.2,0.5-1.9,0.5c-0.9,0-1.6-0.2-2-0.7v3.4h-3.3 v-10.8h3.1v0.7c0.5-0.5,1.2-0.8,2.2-0.8C204.9,186.7,205.5,186.8,206.1,187.2z M204.3,191.9c0.2-0.3,0.4-0.7,0.4-1.1 c0-0.5-0.1-0.9-0.4-1.2c-0.2-0.3-0.6-0.4-0.9-0.4c-0.4,0-0.7,0.1-0.9,0.4c-0.2,0.3-0.4,0.7-0.4,1.2c0,0.5,0.1,0.9,0.4,1.1 c0.2,0.3,0.6,0.4,0.9,0.4C203.8,192.3,204.1,192.2,204.3,191.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.1f4fab20e9ac87de4c4a393d872e4dfd.svg";
export { ForwardRef as ReactComponent };